import {
  getAllReport,
  getReport,
  getDropdown,
  getpaymentDropdown,
  getrecords,
} from "@/http/reports";

export default {
  namespaced: true,
  state: {
    all: [],
    clientsList: [],
    Report: { data: [] },
    list: { data: [] },
    paymentlist: { data: [] },
    Record: { data: [] },
  },
  actions: {
    setAllList({ commit }, data) {
      commit("SET_ALL", data);
    },
    async setAllReport({ commit }) {
      const resp = await getAllReport();
      commit("GET_REPORT_DETAILS", resp.data);
      return resp;
    },
    async setReport({ commit }, data) {
      const resp = await getReport(data.Name);
      commit("SET_REPORT", resp.data);
      return resp;
    },
    async setDropdown({ commit }) {
      const resp = await getDropdown();
      commit("SET_DROPDOWN", resp.data);
      return resp;
    },
    async setpaymentDropdown({ commit }) {
      const resp = await getpaymentDropdown();
      commit("SET_PAYMENT_DROPDOWN", resp.data);
      return resp;
    },
    async setrecords({ commit }, data) {
      const resp = await getrecords(data);
      commit("SET_RECORDS", resp.data);
      return resp;
    },
    async emptySetRecords({ commit }, data) {
      commit("SET_RECORDS", data);
    },
  },
  mutations: {
    ["SET_ALL"](state, payload) {
      Object.assign(state, { all: payload });
    },
    ["GET_REPORT_DETAILS"](state, payload) {
      Object.assign(state, { clientsList: payload });
    },
    ["SET_REPORT"](state, payload) {
      Object.assign(state, { Report: payload });
    },
    ["SET_DROPDOWN"](state, payload) {
      Object.assign(state, { list: payload });
    },
    ["SET_PAYMENT_DROPDOWN"](state, payload) {
      Object.assign(state, { paymentlist: payload });
    },
    ["SET_RECORDS"](state, payload) {
      Object.assign(state, { Record: payload });
    },
  },
  getters: {
    getAllList(state) {
      return state.all;
    },
  },
};
